module.exports = __webpack_public_path__ + "media/images/e-kvitok/unchecked-393882169d51c5a0e527ef26a8b6c3b2.svg";